// extracted by mini-css-extract-plugin
module.exports = {"width100":"y_dq h_dq","design3Pos":"y_s3 h_dV"};